import { TPaymentGateEnum } from '~graphql/generated/clientGraphql'

/**
 * Payment methods (gate enum values) that are usually paid after the order is made
 * (at handover time).
 */
const POST_PAID_PAYMENT_METHODS: RoA<TPaymentGateEnum> = ['CASH', 'CREDIT']

/**
 * Payment methods (gate enum values) that are usually paid before the order is submitted to the branch
 * (as part of the order creating process).
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const PRE_PAID_PAYMENT_METHODS: RoA<TPaymentGateEnum> = [
  'CSOB',
  'PAYU',
  'GOPAY',
  'PAY_FAST',
  'GP_WEBPAY',
]

/**
 * @Returns whether the provided payment method (gate enum) is a post-paid method or not.
 */
export const isPostPaidMethod = (paymentMethodGateEnum: TPaymentGateEnum) => {
  return POST_PAID_PAYMENT_METHODS.includes(paymentMethodGateEnum)
}
